import { smartRound } from '@/utils/miscUtils';
import { getCostsUnit, normalize } from '@/utils/pathwayTemplateUtils';
import { useTeaData } from '@/stores/pathwayTemplateAnalysisStore';
import LoadingSkeleton from '../core/LoadingSkeleton';
import AnalysisBox from '../core/AnalysisBox';
import AnalysisContainer from '../core/AnalysisContainer';

const CostsBreakdownTable = () => {
  const { data, loading, error } = useTeaData();

  if (loading && !data) return <LoadingSkeleton />;
  if (error) return <div>Error: {error.message}</div>;

  const feedstocCosts =
    normalize(data?.feedstock_costs, 'description', 'levelized_contribution.scalar')?.filter(
      item => !/(Splitter|Mixer)/i.test(item.label),
    ) || [];
  const levelizedCosts = normalize(data?.levelized_costs, 'label', 'cost') || [];

  const costs = [...levelizedCosts.filter(item => item.label !== 'Feedstock Cost'), ...feedstocCosts];

  const unit = getCostsUnit(data);
  const total = costs.reduce((sum, item) => sum + item.value, 0);

  return (
    <AnalysisContainer title={`Cost Breakdown (${unit})`}>
      <AnalysisBox>
        {costs.map((item, index) => (
          <div key={index} className="flex justify-between items-center">
            <span className="text-sm text-gray-600">{item.label}</span>
            <span className="text-sm font-semibold text-gray-900">{smartRound(item.value, 2, 3)}</span>
          </div>
        ))}
        <div className="flex justify-between items-center pt-3 border-t border-gray-200/30">
          <span className="text-sm font-semibold text-gray-900">Total</span>
          <span className="text-sm font-bold text-gray-900">{smartRound(total, 2, 3)}</span>
        </div>
      </AnalysisBox>
    </AnalysisContainer>
  );
};

export default CostsBreakdownTable;
